/* Emnefilter til blogoversigterne — uden sideskift.

   Tag-linkene peger stadig på rigtige Shopify-URL'er (/blogs/nyheder/tagged/lumoral),
   så de virker uden JavaScript, kan deles og crawles. Når JavaScript er til stede,
   overtages klikket: kortene skjules og vises på stedet, og adressen opdateres med
   history.pushState. Hele siden skulle ellers hentes forfra, hvilket gav et grimt
   hvidt glimt hver gang man skiftede emne.

   Filtreringen dækker de kort, der allerede er udskrevet i gitteret. Bliver en blog
   større end sektionens "antal indlæg", falder man tilbage til serverens egen
   filtrering, fordi resten af artiklerne ikke er i DOM'en — det er samtidig
   tidspunktet, hvor gitteret bør have rigtigt sideskift. */
(function () {
  var roots = document.querySelectorAll('.pd-blog[data-filterable]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var grid = root.querySelector('.pd-bgrid');
    var links = Array.prototype.slice.call(root.querySelectorAll('.pd-blog__filter a[data-tag]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.pd-bcard'));
    if (!grid || !links.length || !cards.length) return;

    var mosaic = root.getAttribute('data-layout') === 'mosaic';

    /* Kortformerne fordeles efter rækkefølge, så de skal regnes om hver gang udvalget
       ændrer sig — ellers ville blikfanget blive ved med at sidde på en artikel, der
       lige er blevet filtreret væk. Under fire synlige kort droppes mosaikken, og
       under tre bliver gitteret to kolonner, så få kort ikke ser forladte ud. */
    function reshape() {
      var visible = cards.filter(function (card) { return !card.hidden; });

      cards.forEach(function (card) {
        card.classList.remove('pd-bcard--feature', 'pd-bcard--wide');
      });

      var useMosaic = mosaic && visible.length >= 4;
      grid.classList.toggle('pd-bgrid--even', !useMosaic);
      grid.classList.toggle('pd-bgrid--sparse', visible.length > 0 && visible.length <= 2);

      if (!useMosaic) return;

      visible.forEach(function (card, index) {
        if (index === 0) {
          card.classList.add('pd-bcard--feature');
        } else if (index % 5 === 0) {
          card.classList.add('pd-bcard--wide');
        }
      });
    }

    function apply(handle) {
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split('|');
        card.hidden = handle !== '' && tags.indexOf(handle) === -1;
      });

      links.forEach(function (link) {
        if (link.getAttribute('data-tag') === handle) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      reshape();
    }

    function handleFromPath(path) {
      var match = path.match(/\/tagged\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        // Lad browseren selv om midterklik, ctrl/cmd-klik og lignende.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();

        var handle = link.getAttribute('data-tag');
        apply(handle);
        history.pushState({ pdTag: handle }, '', link.getAttribute('href'));
      });
    });

    window.addEventListener('popstate', function () {
      apply(handleFromPath(location.pathname));
    });

    // Ved direkte indgang på en /tagged/-adresse har serveren allerede filtreret, og
    // der er intet at skjule. Kaldet her sørger blot for, at kortformerne passer til
    // det antal, der faktisk står på siden.
    reshape();
  });
})();
